import { SecretaryRequestType } from "../../../types/types";
import { api } from "../api";

/**
 * secretaryOnUpdateData - Function that updates on database an existing secretary by id  
 * /secretaries/{id}  
 * method PUT  
 * @async-function
 */
const secretaryOnUpdateData = async (token: string, model: SecretaryRequestType, id: number) => {
    const response = await api.put(
        `/secretaries/${id}`, {
            ...model
        }, {
            headers: {
                'Authorization': `Bearer ${token}`
            }
        }
    );
    return response;
};

export default secretaryOnUpdateData;